import { useQuery } from 'react-query';
import { Project } from 'src/services/napi/projects/interfaces/fetchProjects.interface';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { fetchCustomersPaginated } from 'src/services/napi/customers/fetchCustomersPaginated';
import { HALF_HOUR } from '../../../../constant/time';
import { useNotification } from '../../../../providers/notificationsProvider';

const getCustomersPaginated = async (page?: string, pageSize?: string, status?: string) => {
  const currentProject = getDataFromLocalStorage<Project>(LocalStorageKey.CURRENT_PROJECT);

  if (!currentProject?._id) return;

  const statusToLowerCase = status?.toLocaleLowerCase() || '';
  const isStatusEmptyOrAll = statusToLowerCase?.length === 0 || statusToLowerCase === 'all';

  const data = await fetchCustomersPaginated({
    current: page || '1',
    limit: pageSize || '10',
    projectId: currentProject._id,
    status: isStatusEmptyOrAll ? '' : statusToLowerCase
  });
  return { paging: data?.paging, users: data?.users };
};

export const useGetCustomersPaginatedQuery = (params: {
  customerId?: string;
  page?: string;
  pageSize?: string;
  status?: string;
}) => {
  const { notify } = useNotification();

  return useQuery(
    [QueryKey.CUSTOMERS, params.customerId, params.page, params.pageSize, params.status],
    () => getCustomersPaginated(params.page, params.pageSize, params.status),
    {
      keepPreviousData: true,
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      },
      staleTime: HALF_HOUR
    }
  );
};
